module.exports = __webpack_public_path__ + "static/media/map-marked-alt-solid.bc4433e5.svg";